import React from 'react';
import * as media from "../../../media";
import styled from "styled-components";
import TranslateText from 'src/text/modal';
import CurrentLanguageContext from 'src/context/currentLanguageContext';

const Card = styled.div`
  text-align: center;
  max-width: 265px;
  margin: 10px;
  width: min-content;
`

const Princip = styled.div`
  justify-content: space-around;
  display: flex;
  margin-top: 20px;
  padding-bottom: 10px;
  ${media.smallerThan(4000)` flex-direction: column-reverse; align-items: center; & > div { width: 100% !important; }`}
`

const DynamicFont = styled.div`
  white-space: nowrap;
  color: #173DB0;
   ${media.biggerThan(1500)` font-size: 60px;`}
   ${media.smallerThan(1500)` font-size: 60px;`}
   ${media.smallerThan(1086)` font-size: 40px;`}
`

const DynamicFontBottom = styled.div`
  margin-top: 5px;
  white-space: normal;
  font-size: 16px;
  
  ${media.biggerThan(1500)` font-size: 16px;`}
  ${media.smallerThan(1500)` font-size: 12px;`}
  ${media.smallerThan(1086)` font-size: 16px;`}
`

export default function desctop() {
  return (
    <CurrentLanguageContext.Consumer>
      {currentLanguage => {
        return currentLanguage === 'en' ? null : (
          <Princip>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                marginLeft: -10,
                marginTop: -10,
                justifyContent: 'space-between',
              }}
            >
              <Card>
                <DynamicFont>50+</DynamicFont>
                <DynamicFontBottom><TranslateText id="main_info__mark_auto" place="bottom" /></DynamicFontBottom>
              </Card>
              <Card>
                <DynamicFont>1000+</DynamicFont>
                <DynamicFontBottom><TranslateText id="mark_info__catalogue_items" place="bottom" /></DynamicFontBottom>
              </Card>
              {currentLanguage !== 'ua' &&
                <Card>
                  <DynamicFont>300+</DynamicFont>
                  <DynamicFontBottom><TranslateText id="mark_info__dillers" place="bottom" /></DynamicFontBottom>
                </Card>
              }
              <Card>
                <DynamicFont>10 000+</DynamicFont>
                <DynamicFontBottom><TranslateText id="mark_info__sale_points" place="bottom" /></DynamicFontBottom>
              </Card>
            </div>
          </Princip>
        );
      }}
    </CurrentLanguageContext.Consumer>
  )
}



// WEBPACK FOOTER //
// ./src/finwhale/common/princip/Desktop.js